/* tslint:disable */
/* eslint-disable */
/* @relayHash 10ac177efce027b0b1d789ae05e88ae3 */

import { ConcreteRequest } from "relay-runtime";
export type PendingBackgroundCheckTab_UpdateIDExpiryMutationVariables = {
    backgroundCheckUUID: string;
    date: string;
};
export type PendingBackgroundCheckTab_UpdateIDExpiryMutationResponse = {
    readonly updateIDExpiryDate: boolean;
};
export type PendingBackgroundCheckTab_UpdateIDExpiryMutation = {
    readonly response: PendingBackgroundCheckTab_UpdateIDExpiryMutationResponse;
    readonly variables: PendingBackgroundCheckTab_UpdateIDExpiryMutationVariables;
};



/*
mutation PendingBackgroundCheckTab_UpdateIDExpiryMutation(
  $backgroundCheckUUID: UUID!
  $date: Time!
) {
  updateIDExpiryDate(backgroundCheckUUID: $backgroundCheckUUID, date: $date)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "backgroundCheckUUID",
            "type": "UUID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "date",
            "type": "Time!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "updateIDExpiryDate",
            "args": [
                {
                    "kind": "Variable",
                    "name": "backgroundCheckUUID",
                    "variableName": "backgroundCheckUUID"
                },
                {
                    "kind": "Variable",
                    "name": "date",
                    "variableName": "date"
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "PendingBackgroundCheckTab_UpdateIDExpiryMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "PendingBackgroundCheckTab_UpdateIDExpiryMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "PendingBackgroundCheckTab_UpdateIDExpiryMutation",
            "id": null,
            "text": "mutation PendingBackgroundCheckTab_UpdateIDExpiryMutation(\n  $backgroundCheckUUID: UUID!\n  $date: Time!\n) {\n  updateIDExpiryDate(backgroundCheckUUID: $backgroundCheckUUID, date: $date)\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '6e3ab27ec24d084e2c728bbd21ebe329';
export default node;
